import { customFetch } from '../lib/network/Axios';

export type CmsValueType = 'TEXT' | 'MARKDOWN' | 'IMAGE_URL' | 'JSON';

export interface CmsContentBlock {
  id?: number;
  pageKey: string;
  sectionKey: string;
  fieldKey: string;
  value: string;
  valueType: CmsValueType;
}

export interface CmsBlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  body: string;
  coverImageUrl: string;
  authorName: string | null;
  category: string | null;
  tags: string[] | null;
  published: boolean;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CmsBlogListResponse {
  data: CmsBlogPost[];
  meta: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const getCmsContent = async (pageKey?: string): Promise<{ blocks: CmsContentBlock[] }> => {
  const response = await customFetch.get('/cms/content', {
    params: pageKey ? { pageKey } : {},
  });

  return {
    blocks: response.data?.blocks || [],
  };
};

export const saveCmsContentBlocks = async (blocks: CmsContentBlock[]) => {
  const response = await customFetch.put('/cms/content', { blocks });
  return response.data;
};

export const deleteCmsContentBlock = async (block: Pick<CmsContentBlock, 'pageKey' | 'sectionKey' | 'fieldKey'>) => {
  const response = await customFetch.delete('/cms/content', {
    params: {
      pageKey: block.pageKey,
      sectionKey: block.sectionKey,
      fieldKey: block.fieldKey,
    },
  });

  return response.data;
};

export const listCmsBlogPosts = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  category?: string;
}): Promise<CmsBlogListResponse> => {
  const response = await customFetch.get('/cms/blog/posts', {
    params,
  });

  return response.data;
};

export const createCmsBlogPost = async (payload: Partial<CmsBlogPost>) => {
  const response = await customFetch.post('/cms/blog/posts', payload);
  return response.data;
};

export const updateCmsBlogPost = async (id: number, payload: Partial<CmsBlogPost>) => {
  const response = await customFetch.patch(`/cms/blog/posts/${id}`, payload);
  return response.data;
};

export const publishCmsBlogPost = async (id: number, published: boolean) => {
  const response = await customFetch.patch(`/cms/blog/posts/${id}/publish`, { published });
  return response.data;
};

export const deleteCmsBlogPost = async (id: number) => {
  const response = await customFetch.delete(`/cms/blog/posts/${id}`);
  return response.data;
};

export const triggerCmsDeploy = async (target = 'e2g-website', reason?: string) => {
  const response = await customFetch.post('/cms/trigger-deploy', { target, reason });
  return response.data;
};
